'use client';

import { c as _c } from "react/compiler-runtime";
import { useInitiatives } from '@/lib/hooks/useInitiatives';
import { InitiativesView } from './InitiativesView';
import type { InitiativesQuery } from '@/lib/api/types';
interface EntityInitiativesProps {
  entityId: number;
  entityType: 'entity' | 'user';
  /** When true, also includes initiatives from other owners that have a @linked=<entityType>:<entityId> system tag */
  includeLinkedInitiatives?: boolean;
  limit?: number;
  emptyMessage?: string;
  status?: InitiativesQuery['status'];
  type?: InitiativesQuery['type'];
  /** When true, excludes template initiatives from results. Defaults to false. */
  excludeTemplates?: boolean;
  /** When true, shows a 'Trade Only' badge on initiatives with visibility='trade' */
  showTradeOnlyBadge?: boolean;
  /** URL to navigate back to (appended as query param to initiative links) */
  backUrl?: string;
  /** Label for the back link (e.g. "Back to X Trade Hub") */
  backLabel?: string;
}

/**
 * Entity Initiatives Component
 * Simple wrapper around InitiativesView that fetches initiatives for a specific entity.
 * When includeLinkedInitiatives is true, also fetches initiatives linked to this entity
 * via @linked system tags (e.g. initiatives owned by other entities but linked to this one).
 */
export function EntityInitiatives(t0) {
  const $ = _c(23);
  const {
    entityId,
    entityType,
    includeLinkedInitiatives: t1,
    limit: t2,
    status,
    type,
    excludeTemplates: t3,
    showTradeOnlyBadge: t4,
    emptyMessage: t5,
    backUrl,
    backLabel
  } = t0;
  const includeLinkedInitiatives = t1 === undefined ? true : t1;
  const limit = t2 === undefined ? 6 : t2;
  const excludeTemplates = t3 === undefined ? false : t3;
  const showTradeOnlyBadge = t4 === undefined ? false : t4;
  const emptyMessage = t5 === undefined ? "No active initiatives, check back soon, or follow for notifications" : t5;
  let t6;
  if ($[0] !== entityId) {
    t6 = entityId.toString();
    $[0] = entityId;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let query;
  if ($[2] !== entityId || $[3] !== entityType || $[4] !== excludeTemplates || $[5] !== includeLinkedInitiatives || $[6] !== limit || $[7] !== status || $[8] !== t6 || $[9] !== type) {
    query = {
      ownerId: t6,
      ownerType: entityType,
      limit,
      status,
      type
    };
    if (excludeTemplates) {
      query.isTemplate = false;
    }
    if (includeLinkedInitiatives) {
      query.includeLinkedToType = entityType;
      let t7;
      if ($[11] !== entityId) {
        t7 = entityId.toString();
        $[11] = entityId;
        $[12] = t7;
      } else {
        t7 = $[12];
      }
      query.includeLinkedToId = t7;
    }
    $[2] = entityId;
    $[3] = entityType;
    $[4] = excludeTemplates;
    $[5] = includeLinkedInitiatives;
    $[6] = limit;
    $[7] = status;
    $[8] = t6;
    $[9] = type;
    $[10] = query;
  } else {
    query = $[10];
  }
  const {
    data,
    isLoading
  } = useInitiatives(query);
  let t7;
  if ($[13] !== data?.pages?.[0]?.initiatives) {
    t7 = data?.pages?.[0]?.initiatives || [];
    $[13] = data?.pages?.[0]?.initiatives;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const initiatives = t7;
  const t8 = entityType === "entity" ? entityId : undefined;
  let t9;
  if ($[15] !== backLabel || $[16] !== backUrl || $[17] !== emptyMessage || $[18] !== initiatives || $[19] !== isLoading || $[20] !== showTradeOnlyBadge || $[21] !== t8) {
    t9 = <InitiativesView initiatives={initiatives} isLoading={isLoading} showDates={true} emptyMessage={emptyMessage} variant="compact" entityId={t8} showTradeOnlyBadge={showTradeOnlyBadge} backUrl={backUrl} backLabel={backLabel} />;
    $[15] = backLabel;
    $[16] = backUrl;
    $[17] = emptyMessage;
    $[18] = initiatives;
    $[19] = isLoading;
    $[20] = showTradeOnlyBadge;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}